export const NecessaryCookies = {
  cookiesTable: [
    {
      vendor: 'Workable',
      vendorURL: 'https://www.workable.com',
      cookies:
        '_workable_csrf_token, _workable_first_publish, _workable_mobile, _workable_sw, workable_auth_token, _workable_visitor, _workable_session, _workable_session_state, _workable_current_feedback_provider_email_<TOKEN>, _workable_prefs, _workabl, _grant, _grant_resume, _session, ad_banner_dismissed'
    },
    {
      vendor: 'Hubspot',
      vendorURL: 'https://legal.hubspot.com/privacy-policy',
      cookies:
        '__hs_do_not_track, __hs_opt_out, __hs_initial_opt_in, __hs_cookie_cat_pref, hs_c2l, __cfduid, hs_notify_banner_dismiss'
    },
    {vendor: 'LeanData', vendorURL: 'https://www.leandata.com/privacy/', cookies: 'user_bookit'},
    {
      vendor: 'Cloudfare',
      vendorURL: 'https://www.cloudflare.com/en-gb/privacypolicy/',
      cookies: '__cfruid, __cfduid, _session_id, __cfruid, _cfuvid'
    },
    {
      vendor: 'New Relic',
      vendorURL: 'https://newrelic.com/termsandconditions/privacy',
      cookies: 'JSESSIONID'
    },
    {
      vendor: 'Datadog',
      vendorURL: 'https://www.datadoghq.com/legal/privacy/',
      cookies: 'dd_cookie_test_xx, _dd_s'
    },
    {
      vendor: 'Stripe',
      vendorURL: 'https://stripe.com/en-gr/privacy',
      cookies: '__stripe_mid, __stripe_sid'
    },
    {
      vendor: 'Upscope',
      vendorURL: 'https://app.upscope.io/api/contracts/privacy.pdf',
      cookies: '_upscope__waitingForCallAt'
    },
    {
      vendor: 'Zendesk',
      vendorURL: 'https://www.zendesk.com/company/agreements-and-terms/privacy-notice/',
      cookies: '__zlcmid'
    }
  ]
};
